import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { SkuInfoBlock } from "@components"
import { useBuildExternalURL } from "@hooks"
import { useCatalogueDetailsShowEvolution } from "../@hooks"
import { CatalogueDetailsPriceEvolutionFilters } from "../../@signals"


export default function productColumn() {
	return [{
        name: 'brand', label: 'Brand',
        options: {
            display: 'excluded'
        }
    },{
		name:'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	},{
		name: 'productTitle', label: 'Product Name',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			setCellHeaderProps: () => ({ sx: { minWidth: 300 }}),
			customBodyRowRenderLite: (value, row) => {
				const { brand, ean, siteID, productID, reference } = row
				const { productURL } = useBuildExternalURL({
					siteData: { siteID, productID }
				})

				return <Box>
					<SkuInfoBlock
						sku={value}
						brand={brand}
						ean={ean}
						reference={reference}
						productURL={productURL}
					/>
					<ShowPriceEvolutionCell siteID={siteID} productID={productID} />
				</Box>
			}
		}
	}]
}

const ShowPriceEvolutionCell = ({siteID, productID}) => {

	const { handleClickShowEvolution } = useCatalogueDetailsShowEvolution(siteID, productID)
 
	 return <Box display="flex" alignItems="flex-end" onClick={() => handleClickShowEvolution(CatalogueDetailsPriceEvolutionFilters)} >
		 <Typography variant="caption" sx={{ display: 'block', color: "text.primary", mt: 1, mr: 0.5, cursor: 'pointer', "&:hover":{ textDecoration: 'underline'} }}>
			 Show Price & Stock Evolution 
		 </Typography>
		 <IconSeeker icon={'chart-line'} sx={{ mr: 0.5, margin: .5, color: 'primary.main'}}/>
	 </Box>
 
 }